module.exports = __webpack_public_path__ + "img/image_16.e6561672.png";